import { defineGlobalStyles } from '@chakra-ui/react';
export const globalCss = defineGlobalStyles({
    body: {
        fontSize: '16px',
        color: 'text.default',
        bgColor: 'background.skyBlue',
        cursor: "url('/cursor.svg'), auto",
    },
    // no scrollbar
    '.no-scrollbar::-webkit-scrollbar': {
        display: 'none',
    },
    '.no-scrollbar': {
        scrollbarWidth: 'none',
    },
});
